import { useState } from "react";
import { intl } from "LocaleWrapper";
import { CallLink, CargoLink, ContractLink, DossierLink } from "utils/LinkUtils";
import { CommentableEntity, CommentCall, CommentCargo, CommentContract, SelectedCommentableEntity } from "./utils";
import { CommentEntityType } from "__generated__/enums";

interface UseCommentsProps {
	collapsableDisabled?: boolean,
	cargos?: CommentCargo[];
	calls?: CommentCall[];
	contracts?: CommentContract[];
	onChange?: () => void;
}

export const useComments = ({ collapsableDisabled, cargos, calls, contracts, onChange }: UseCommentsProps) => {

	const [ selectedEntity, selectEntity ] = useState<SelectedCommentableEntity | null>(null);

	const getEntities = () => {

		const entities: CommentableEntity[] = [];

		if (cargos) {
			cargos.forEach(c => {
				entities.push({
					id: c.id,
					name: c.cargoNumber || c.containerNumber || c.product?.name || intl.formatMessage({ id: "UNKNOWN" }),
					title: (
						<div style={{ width: "100%" }}>
							<div>
								<CargoLink cargo={c} />
							</div>
							{c.charter && (
								<div>
									<DossierLink charter={c.charter} />
								</div>
							)}
						</div>

					),
					type: CommentEntityType.Cargo,
					comments: c.comments || [],
				});
			});
		}

		if (calls) {
			calls.forEach(c => {
				entities.push({
					id: c.id,
					name: `${c.location?.description} (${c.voyage?.voyageNumber})`,
					title: <CallLink call={c} />,
					type: CommentEntityType.Call,
					comments: c.comments || [],
				});
			});
		}

		if (contracts) {
			contracts.forEach(c => {
				entities.push({
					id: c.id,
					name: c.contractNumber || intl.formatMessage({ id: "UNKNOWN" }),
					title: <ContractLink contract={c} />,
					type: CommentEntityType.Contract,
					comments: c.comments || [],
				});
			});
		}

		return entities;
	};

	return {
		commentsProps: {
			collapsableDisabled: collapsableDisabled,
			entities: getEntities(),
			onChange: onChange,
			openCommentsByEntity: selectedEntity,
			onClose: () => selectEntity(null),
		},

		openComment: (id: number, entityType: CommentEntityType) => {
			selectEntity({
				id: id,
				type: entityType,
			});
		},
	};
};

export default useComments;
